// GPH Expert Intelligence Core — Research Decision Engine (frontend, PDS §8.1).
// Decide QUANDO pesquisar. O backend recalcula a decisão (nunca confia no
// cliente) — esta camada evita chamadas desnecessárias e informa a UI.

const RESEARCH_TRIGGERS = /\b(melhor|atual|meta|patch|temporada|season|novo|nova|mais forte|pro player|ultima atualizacao|última atualização|attachment|attachments|balanceamento|buff|nerf|tier list|ranking)\b/;

const NO_RESEARCH = /\b(oi|ola|olá|bom dia|boa noite|calcul|calculadora|meu plano|favorit|configurac|assinar|sair da conta)\b/;

export const evaluateResearch = (normalizedText = '', { intent = null, isSlotFilling = false, isContextAction = false } = {}) => {
  if (isSlotFilling || isContextAction) {
    return { shouldResearch: false, reason: 'slot_filling_or_context_action', queryType: 'none', confidenceWithoutResearch: 0.9 };
  }
  if (!normalizedText || NO_RESEARCH.test(normalizedText)) {
    return { shouldResearch: false, reason: 'local_or_low_intent', queryType: 'none', confidenceWithoutResearch: 0.95 };
  }
  if (intent === 'calculator_request' || intent === 'raw_config_value') {
    return { shouldResearch: false, reason: 'local_calculation', queryType: 'none', confidenceWithoutResearch: 0.95 };
  }
  if (RESEARCH_TRIGGERS.test(normalizedText)) {
    return { shouldResearch: true, reason: 'depends_on_current_meta_or_patch', queryType: 'web_and_video', confidenceWithoutResearch: 0.55 };
  }
  if (intent === 'training_request') {
    // Material de apoio melhora treino, mas não é obrigatório.
    return { shouldResearch: true, reason: 'support_material_improves_training', queryType: 'video', confidenceWithoutResearch: 0.75 };
  }
  return { shouldResearch: false, reason: 'internal_knowledge_sufficient', queryType: 'none', confidenceWithoutResearch: 0.85 };
};

export default evaluateResearch;
